/**
 * US phone number utility functions for formatting and validation.
 */

export function formatUSPhone(raw: string): string {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('1')) digits = digits.slice(1);
  digits = digits.slice(0, 10);

  if (digits.length === 0) return '';
  if (digits.length <= 3) return `+1 (${digits}`;
  if (digits.length <= 6) return `+1 (${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function isValidUSPhone(formatted: string): boolean {
  if (!formatted) return true;
  const digits = formatted.replace(/\D/g, '');
  const cleaned = digits.startsWith('1') ? digits.slice(1) : digits;
  return cleaned.length === 10;
}
